import store from '@/store'
import storage from './storage'
import moment from 'moment-timezone'
const apiUrlProd = window.config ? window.config.apiUrlProd : ''
const authUrl = window.config ? window.config.authUrl : ''
const signalrUrl = window.config ? window.config.signalrUrl : ''
const testMode = window.config ? window.config.testMode : false

export default {
  namespaced: true,
  generateUUID() {
    // Timestamp
    var d = new Date().getTime()
    // Time in microseconds since page-load or 0 if unsupported
    var d2 = (performance && performance.now && (performance.now() * 1000)) || 0
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      // random number between 0 and 16
      var r = Math.random() * 16
      // Use timestamp until depleted
      if (d > 0) {
        r = (d + r) % 16 | 0
        d = Math.floor(d / 16)
      } else {
        // Use microseconds since page-load if supported
        r = (d2 + r) % 16 | 0
        d2 = Math.floor(d2 / 16)
      }
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
    })
  },
  formatDateTimeCultural: function (date) {
    let language = store.getters['auth/language']
    if (date !== undefined && date !== null) {
      if (language !== '') {
        language += '-' + language.toUpperCase()
        return date.toLocaleString(language)
      } else {
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
      }
    } else {
      return null
    }
  },
  formatDateCultural: function (date) {
    if (date !== undefined && date !== null) {
      let language = store.getters['auth/language']
      if (language !== '') {
        language += '-' + language.toUpperCase()
        return date.toLocaleDateString(language)
      } else {
        return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear()
      }
    }
  },
  formatTimeCultural: function (date) {
    if (date !== undefined && date !== null) {
      let language = store.getters['auth/language']
      if (language !== '') {
        language += '-' + language.toUpperCase()
        return date.toLocaleTimeString(language)
      } else {
        var hours = date.getHours()
        var minutes = date.getMinutes()
        var ampm = hours >= 12 ? 'pm' : 'am'
        hours = hours % 12
        hours = hours || 12 // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes
        var strTime = hours + ':' + minutes + ' ' + ampm
        return strTime
      }
    }
  },
  formatDateTime: function (date) {
    if (date !== undefined && date !== null) {
      let language = store.getters['auth/language']
      if (language !== '') {
        language += '-' + language.toUpperCase()
        return date.toLocaleString(language)
      } else {
        var hours = date.getHours()
        var minutes = date.getMinutes()
        var ampm = hours >= 12 ? 'pm' : 'am'
        hours = hours % 12
        hours = hours || 12 // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes
        var strTime = hours + ':' + minutes + ' ' + ampm
        return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear() + ' ' + strTime
      }
    } else {
      return null
    }
  },
  formatDateTimeLong: function (date) {
    if (date !== undefined && date !== null) {
      var hours = date.getHours()
      var minutes = date.getMinutes()
      hours = hours < 12 ? '0' + hours : hours
      minutes = minutes < 10 ? '0' + minutes : minutes
      var strTime = 'T' + hours + ':' + minutes
      var month = date.getMonth() + 1
      month = month < 10 ? '0' + month : month
      var day = date.getDate()
      day = day < 10 ? '0' + day : day
      return date.getFullYear() + '-' + month + '-' + day + strTime
    } else {
      return null
    }
  },
  formatDateTime2: function (date) {
    var today = new Date()
    var hours = date.getHours()
    var ampm = 'am'
    if (hours >= 12) {
      ampm = 'pm'
    }
    if (hours >= 13) {
      hours = hours - 12
    }
    var year = today.getFullYear()
    if (today.getMonth() === 11 && date.getMonth() === 0) {
      year++
    }
    return (date.getMonth() + 1) + '/' + date.getDate() + '/' + year + ' ' + hours + ':' + date.getMinutes() + ' ' + ampm
  },
  formatDateTimeWithTimezone: function (date, timezone) {
    return moment(date).tz(timezone).format('YYYY-MM-DD HH:mm:ss')
  },
  getTimezones: function () {
    // let countries = []
    console.log(JSON.stringify(moment.tz.countries()))
  },
  getDay: function () {
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    var now = new Date()
    return days[now.getDay()]
  },
  getTime: function (includeSeconds) {
    var now = new Date()
    var ampm = ' am'
    var hours = now.getHours()
    if (hours > 12) {
      hours = hours - 12
      ampm = ' pm'
    }
    var minutes = now.getMinutes()
    if (minutes < 10) {
      minutes = '0' + minutes
    }
    if (includeSeconds !== undefined) {
      if (includeSeconds) {
        var seconds = now.getSeconds()
        if (seconds < 10) {
          seconds = '0' + seconds
        }
        minutes += ':' + seconds
      }
    }
    return hours + ':' + minutes + ampm
  },
  getMessageTime: function (messageTime) {
    const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
    var _getDay = val => {
      let lastDigit = parseInt(val.toString().slice(-1))
      let day = parseInt(val)
      if (lastDigit === 1) {
        return day + 'st'
      } else if (lastDigit === 2) {
        return day + 'en'
      } else if (lastDigit === 3) {
        return day + 'rd'
      } else {
        return day + 'th'
      }
    }
    var _checkTime = val => {
      return +val < 10 ? '0' + val : val
    }
    if (messageTime) {
      const LAST_MESSAGE_YESTERDAY = 'YESTERDAY'
      var _nowDate = new Date()
      var _date = null
      if (messageTime !== undefined) {
        _date = new Date(messageTime)
      }
      if (_date !== null) {
        if (_nowDate.getDate() - _date.getDate() === 1) {
          return LAST_MESSAGE_YESTERDAY
        } else if (
          _nowDate.getFullYear() === _date.getFullYear() &&
          _nowDate.getMonth() === _date.getMonth() &&
          _nowDate.getDate() === _date.getDate()
        ) {
          return _checkTime(_date.getHours()) + ':' + _checkTime(_date.getMinutes())
        } else {
          return months[_date.getMonth()] + ' ' + _getDay(_date.getDate())
        }
      } else {
        return ''
      }
    }
    return ''
  },
  elapsedTime: function (time, status) {
    // Resource: http://jsfiddle.net/cckSj/5/
    if (['closed', 'voided ro'].indexOf(status.toLowerCase()) > -1) {
      return null
    }
    // Time when the change was made on database (database time)
    var startTime
    if (time === 'now') {
      startTime = new Date(moment().subtract(1, 'minutes').tz('US/Central').format('YYYY-MM-DD HH:mm:ss'))
    } else {
      startTime = new Date(time)
    }
    // Current time (user time)
    // IMPORTANT: I'm adding a minute since seems like PROD DB has 12 seconds behind of difference making it to display a negative -1 minute instead of 0 minutes.
    var endTime = new Date(moment().add(1, 'minutes').tz('US/Central').format('YYYY-MM-DD HH:mm:ss'))
    // time difference in ms
    var timeDiff = endTime - startTime
    // strip the miliseconds
    timeDiff /= 1000
    // get seconds
    // var seconds = Math.round(timeDiff % 60)
    // remove seconds from the date
    timeDiff = Math.floor(timeDiff / 60)
    // get minutes
    var minutes = Math.round(timeDiff % 60)
    // remove minutes from the date
    timeDiff = Math.floor(timeDiff / 60)
    // get hours
    var hours = Math.round(timeDiff % 24)
    // remove hours from the date
    timeDiff = Math.floor(timeDiff / 24)
    // the rest of timeDiff is number of days
    var days = timeDiff
    var timeElapsed = ''
    // Show day(s)
    if (days > 0) {
      timeElapsed = days === 1 ? days + ' day, ' : days + ' days, '
    }
    // Show Hours
    if (hours > 0) {
      timeElapsed += hours > 0 ? hours === 1 ? hours + ' hr ' : hours + ' hrs ' : ' '
    }
    // Show Minutes
    // Since we aren't displaying seconds we have the following problem:
    // Sometimes, seconds equals to ~59 and minutes equals to 0.
    // So, in that case, "x minutes" won't be display at the DOM because it's 0. To fix this, we'll set minutes to 1 if it's actually 0.
    // With this, even if minutes equals 0 (really ~59 seconds), it will be displayed as "1 minute"
    minutes = minutes === 0 ? 1 : minutes
    if (minutes > 0) {
      timeElapsed += minutes === 1 ? minutes + ' min ' : minutes + ' mins '
    }
    if (days > 1000) {
      timeElapsed = status
    }
    // Update object
    return timeElapsed
  },
  isNumeric: function (n) {
    return !isNaN(parseFloat(n)) && isFinite(n)
  },
  getBase64Image: function (img) {
    // https://stackoverflow.com/questions/19183180/how-to-save-an-image-to-localstorage-and-display-it-on-the-next-page
    var canvas = document.createElement('canvas')
    canvas.width = img.width
    canvas.height = img.height
    var ctx = canvas.getContext('2d')
    ctx.drawImage(img, 0, 0)
    var dataURL = canvas.toDataURL('image/png')
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, '')
  },
  get currentPage() {
    return storage.session.getItem('currentPage')
  },
  set currentPage(value) {
    storage.session.setItem('currentPage', value)
  },
  logging: false,
  logEntries: [],
  lookupUrl: function (solution) {
    let _url = apiUrlProd
    return _url
  },
  apiUrl: function () {
    let _url = apiUrlProd
    return _url
  },
  authUrl: function () {
    let _url = authUrl
    return _url
  },
  signalrUrl: function () {
    let _url = signalrUrl
    return _url
  },
  get testMode() {
    return testMode
  },
  get username() {
    return storage.session.getItem('username')
  },
  set username(value) {
    storage.session.setItem('username', value)
  },
  get email() {
    return storage.session.getItem('email')
  },
  set email(value) {
    storage.session.setItem('email', value)
  },
  getApp: function () {
    return storage.local.getItem('appId')
  },
  setApp: function (id) {
    storage.local.setItem('appId', id)
    let _type = 'ServiceRequest'
    if (id === 2) {
      _type = 'ServiceRequestGlass'
    } else if (id === 4) {
      _type = 'ServiceRequestCalibration'
    }
    storage.local.setItem('channelType', _type)
  },
  getChannelType: function () {
    return storage.local.getItem('channelType')
  },
  sortArray(data) {
    let _data = Array.from(new Set(data)).sort(function (a, b) {
      if (a[0] === b[0]) {
        var x = a['name']
        var y = b['name']
        return x < y ? -1 : x > y ? 1 : 0
      }
      return a[0] - b[0]
    })
    return _data
  },
  jsonToQueryString(json) {
    let query = ''
    if (json !== undefined && json !== null) {
      query = '?' + Object.keys(json).map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
      }).join('&')
    }
    return query
  }
}



// WEBPACK FOOTER //
// ./src/plugins/globals.js